/**
 * LinkMenu produces an unordered list of links.
 * Supported props: links, listStyle, itemStyle, localizerfn
 */
import React from 'react';
import Safe from './Safe';

export default function LinkMenu(props) {
  const defaultListStyle = 'nav navbar-nav nav-gvs navbar-right main-menu'
  const defaultItemStyle = 'menu__item is-leaf is-active first leaf active';
  if (!Array.isArray(props.links)) return <p>Improperly configured links!</p>;

  return (
    <ul className={props.listStyle || defaultListStyle}>
      {
        props.links.map((link, index) =>
          <li key={`li_${index}`} className={props.itemStyle || defaultItemStyle}>
            {makeLink(link, index, props.localizerfn)}
          </li>
        )
      }
    </ul>
  );
};

function makeLink(link, index, localized) {
  if (!link) return <span>?</span>;
  const href = (localized ? localized(link.to) : link.to);
  return (link.to.indexOf('#')>=0 ?
    <Safe type="Link" key={`link_${index}`} to={href} className="menu__link active" content={link.label} /> :
    <Safe type="a" key={`a_${index}`} href={link.to} className="menu__link" content={link.label} />);
}
